module.exports = __webpack_public_path__ + "img/hourlyServer.8ea1faa.svg";